// extracted by mini-css-extract-plugin
export default {"chatMarkdown":"ChatStyles_chatMarkdown__HOeMr"};